// File: frontend/src/services/documentGeneratorService.js
// Version: 1.0
// Date: 2026-04-11
// Description: API service for document generator endpoints — templates, generate, update, export.

import apiService from './apiService';

const documentGeneratorService = {
  async getTemplates() {
    return apiService.makeRequest('/documents/templates');
  },

  async generateDocument(templateId, caseId) {
    return apiService.makeRequest('/documents/generate', {
      method: 'POST',
      body: JSON.stringify({ template_id: templateId, case_id: caseId }),
    });
  },

  async updateDocument(docId, body, isFinalized = false) {
    return apiService.makeRequest(`/documents/generated/${docId}`, {
      method: 'PUT',
      body: JSON.stringify({ body, is_finalized: isFinalized }),
    });
  },

  getExportUrl(docId) {
    return `/api/v1/documents/generated/${docId}/export`;
  },
};

export default documentGeneratorService;
